import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';

export default function Benefits() {
  const { t } = useTranslation();

  // Import calendar events from events page
  const allCalendarEvents = [
    // ========================================
    // GENERAL CONFERENCE SPECIAL DAYS 2026
    // ========================================
    
    // JANUARY 2026
    {
      id: 101,
      title: 'Quarterly Day of Prayer',
      description: 'A special day set aside for united prayer across the global Adventist church, seeking God\'s guidance and blessing for the new quarter.',
      startDate: '2026-01-03',
      endDate: '2026-01-03',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://public.readdy.ai/ai/img_res/1fd536ec821326b85b7916c10609a722.jpg',
      isOnline: true,
    },
    {
      id: 102,
      title: 'Ten Days of Prayer',
      description: 'Global prayer initiative uniting Adventists worldwide in focused prayer and spiritual renewal, seeking revival and reformation.',
      startDate: '2026-01-07',
      endDate: '2026-01-17',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20global%20prayer%20gathering%20with%20people%20from%20different%20nations%20kneeling%20in%20prayer%20warm%20spiritual%20atmosphere%20candles%20soft%20lighting%20peaceful%20worship%20setting%20simple%20background&width=800&height=500&seq=gc-prayer-ten-days-2026&orientation=landscape',
      isOnline: true,
    },

    // MARCH 2026
    {
      id: 103,
      title: 'Women\'s Day of Prayer',
      description: 'A special day dedicated to women\'s prayer ministries, encouraging women worldwide to unite in prayer and spiritual fellowship.',
      startDate: '2026-03-07',
      endDate: '2026-03-07',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20women%20in%20prayer%20circle%20holding%20hands%20peaceful%20worship%20setting%20warm%20lighting%20spiritual%20unity%20feminine%20strength%20simple%20background&width=800&height=500&seq=gc-women-prayer-2026&orientation=landscape',
      isOnline: true,
    },
    {
      id: 104,
      title: 'Adventist World Radio (AWR) Day',
      description: 'Celebrating the global radio ministry that shares the gospel message in multiple languages, reaching unreached people groups worldwide.',
      startDate: '2026-03-14',
      endDate: '2026-03-14',
      category: 'Media',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 105,
      title: 'Global Youth Day (AYM)',
      description: 'Worldwide celebration empowering Adventist youth to serve their communities and share their faith through practical service projects.',
      startDate: '2026-03-21',
      endDate: '2026-03-21',
      category: 'Youth',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Energetic%20global%20youth%20celebration%20with%20diverse%20young%20people%20serving%20communities%20colorful%20banners%20modern%20worship%20vibrant%20atmosphere%20unity%20and%20service%20simple%20background&width=800&height=500&seq=gc-youth-day-2026&orientation=landscape',
      isOnline: false,
    },
    {
      id: 106,
      title: 'Youth Week of Prayer (AYM)',
      description: 'A week dedicated to youth spiritual growth, featuring daily devotionals and prayer meetings designed specifically for young people.',
      startDate: '2026-03-21',
      endDate: '2026-03-28',
      category: 'Youth',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: true,
    },
    {
      id: 107,
      title: 'Global Children\'s Day',
      description: 'Celebrating children\'s ministries worldwide and emphasizing the importance of nurturing faith in young hearts.',
      startDate: '2026-03-21',
      endDate: '2026-03-21',
      category: 'Children',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Joyful%20children%20from%20diverse%20backgrounds%20celebrating%20together%20colorful%20balloons%20happy%20faces%20worship%20activities%20playful%20atmosphere%20simple%20background&width=800&height=500&seq=gc-children-day-2026&orientation=landscape',
      isOnline: false,
    },

    // APRIL 2026
    {
      id: 108,
      title: 'Quarterly Day of Prayer',
      description: 'A special day set aside for united prayer across the global Adventist church, seeking God\'s guidance and blessing for the new quarter.',
      startDate: '2026-04-04',
      endDate: '2026-04-04',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: true,
    },
    {
      id: 109,
      title: 'World Ambassador Day',
      description: 'Recognizing and commissioning church members as ambassadors for Christ in their communities and workplaces.',
      startDate: '2026-04-04',
      endDate: '2026-04-04',
      category: 'Mission',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 110,
      title: 'Literature Evangelism Rally Week',
      description: 'A week dedicated to promoting literature evangelism and supporting those who share faith through printed materials.',
      startDate: '2026-04-11',
      endDate: '2026-04-17',
      category: 'Evangelism',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 111,
      title: 'World Impact Day (Missionary Book Distribution)',
      description: 'Global initiative distributing missionary books to communities, sharing hope and biblical truth through literature.',
      startDate: '2026-04-11',
      endDate: '2026-04-11',
      category: 'Mission',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 112,
      title: 'Hope Channel International Day',
      description: 'Celebrating the global television ministry that broadcasts hope and biblical messages to millions worldwide.',
      startDate: '2026-04-11',
      endDate: '2026-04-11',
      category: 'Media',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 113,
      title: 'Possibility Ministries Day',
      description: 'Highlighting ministries that serve individuals with disabilities, promoting inclusion and accessibility in church life.',
      startDate: '2026-04-18',
      endDate: '2026-04-18',
      category: 'Ministry',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // MAY 2026
    {
      id: 114,
      title: 'Drug Awareness Month',
      description: 'Month-long emphasis on drug prevention, education, and supporting those affected by substance abuse through health ministries.',
      startDate: '2026-05-01',
      endDate: '2026-05-31',
      category: 'Health',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Health%20awareness%20campaign%20with%20educational%20materials%20community%20support%20groups%20wellness%20activities%20hope%20and%20recovery%20theme%20simple%20background&width=800&height=500&seq=gc-drug-awareness-2026&orientation=landscape',
      isOnline: true,
    },
    {
      id: 115,
      title: 'Global Adventurer\'s Day',
      description: 'Celebrating the Adventurer club ministry for children ages 6-9, promoting character development and spiritual growth.',
      startDate: '2026-05-16',
      endDate: '2026-05-16',
      category: 'Children',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 116,
      title: 'World Day of Prayer for Children at Risk',
      description: 'Global prayer initiative focusing on children facing poverty, abuse, trafficking, and other vulnerabilities.',
      startDate: '2026-05-23',
      endDate: '2026-05-23',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: true,
    },

    // JUNE 2026
    {
      id: 117,
      title: 'Women\'s Ministries Emphasis Day',
      description: 'Highlighting the vital role of women in church ministry and leadership, celebrating their contributions and gifts.',
      startDate: '2026-06-13',
      endDate: '2026-06-13',
      category: 'Women',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 118,
      title: 'World Public Campus Ministries Day',
      description: 'Recognizing campus ministries that reach students on public university campuses with the gospel message.',
      startDate: '2026-06-27',
      endDate: '2026-06-27',
      category: 'Youth',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // JULY 2026
    {
      id: 119,
      title: 'Quarterly Day of Prayer',
      description: 'A special day set aside for united prayer across the global Adventist church, seeking God\'s guidance and blessing for the new quarter.',
      startDate: '2026-07-04',
      endDate: '2026-07-04',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: true,
    },
    {
      id: 120,
      title: 'Children\'s Sabbath',
      description: 'A special Sabbath dedicated to celebrating children and emphasizing their importance in the church family.',
      startDate: '2026-07-25',
      endDate: '2026-07-25',
      category: 'Children',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // AUGUST 2026
    {
      id: 121,
      title: 'Global Mission Evangelism',
      description: 'Worldwide evangelistic initiative focusing on reaching unreached people groups and planting new churches.',
      startDate: '2026-08-01',
      endDate: '2026-08-01',
      category: 'Mission',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Global%20mission%20outreach%20with%20diverse%20missionaries%20serving%20communities%20evangelism%20activities%20cross-cultural%20ministry%20hope%20and%20compassion%20simple%20background&width=800&height=500&seq=gc-mission-2026&orientation=landscape',
      isOnline: false,
    },
    {
      id: 122,
      title: 'Reach the World: Church Planting',
      description: 'Special emphasis on church planting strategies and supporting new congregations in unreached areas.',
      startDate: '2026-08-08',
      endDate: '2026-08-08',
      category: 'Mission',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 123,
      title: 'Lay Evangelism Day',
      description: 'Celebrating and empowering lay members to share their faith through personal evangelism and community outreach.',
      startDate: '2026-08-22',
      endDate: '2026-08-22',
      category: 'Evangelism',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // SEPTEMBER 2026
    {
      id: 124,
      title: 'Youth Spiritual & Mission Commitment Day (AYM)',
      description: 'A day for young people to renew their spiritual commitment and dedicate themselves to mission service.',
      startDate: '2026-09-05',
      endDate: '2026-09-05',
      category: 'Youth',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 125,
      title: 'Family Togetherness Week of Prayer',
      description: 'A week dedicated to strengthening family bonds through prayer, worship, and quality time together.',
      startDate: '2026-09-06',
      endDate: '2026-09-12',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20families%20praying%20together%20warm%20home%20setting%20parents%20and%20children%20united%20in%20worship%20love%20and%20togetherness%20peaceful%20atmosphere%20simple%20background&width=800&height=500&seq=gc-family-prayer-2026&orientation=landscape',
      isOnline: true,
    },
    {
      id: 126,
      title: 'Pathfinder Day',
      description: 'Celebrating the Pathfinder club ministry that develops leadership and character in youth through outdoor activities and service.',
      startDate: '2026-09-19',
      endDate: '2026-09-19',
      category: 'Youth',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 127,
      title: 'Sabbath School Guest Day',
      description: 'Special Sabbath encouraging members to invite friends and family to experience Sabbath School fellowship and Bible study.',
      startDate: '2026-09-26',
      endDate: '2026-09-26',
      category: 'Sabbath School',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // OCTOBER 2026
    {
      id: 128,
      title: 'Quarterly Day of Prayer',
      description: 'A special day set aside for united prayer across the global Adventist church, seeking God\'s guidance and blessing for the new quarter.',
      startDate: '2026-10-03',
      endDate: '2026-10-03',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: true,
    },
    {
      id: 129,
      title: 'Pastor Appreciation Day',
      description: 'A day to honor and express gratitude for pastors and their faithful service to the church and community.',
      startDate: '2026-10-10',
      endDate: '2026-10-10',
      category: 'Leadership',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 130,
      title: 'Spirit of Prophecy & Adventist Heritage Sabbath',
      description: 'Celebrating the prophetic gift and rich heritage of the Seventh-day Adventist Church.',
      startDate: '2026-10-17',
      endDate: '2026-10-17',
      category: 'Heritage',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },
    {
      id: 131,
      title: 'Creation Sabbath',
      description: 'Celebrating God as Creator and emphasizing stewardship of the earth and its resources.',
      startDate: '2026-10-24',
      endDate: '2026-10-24',
      category: 'Worship',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // NOVEMBER 2026
    {
      id: 132,
      title: 'Week of Prayer',
      description: 'Annual week dedicated to spiritual reflection, prayer, and deepening relationship with God through daily devotionals.',
      startDate: '2026-11-07',
      endDate: '2026-11-14',
      category: 'Prayer',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20prayer%20gathering%20with%20diverse%20believers%20kneeling%20in%20worship%20soft%20evening%20light%20spiritual%20atmosphere%20unity%20in%20prayer%20simple%20background&width=800&height=500&seq=gc-week-prayer-2026&orientation=landscape',
      isOnline: true,
    },
    {
      id: 133,
      title: 'e-Week of Prayer (Youth & Young Adults)',
      description: 'Digital prayer week designed specifically for youth and young adults, featuring online devotionals and virtual gatherings.',
      startDate: '2026-11-14',
      endDate: '2026-11-20',
      category: 'Youth',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: true,
    },
    {
      id: 134,
      title: 'Annual Sacrifice (Mission Promotion)',
      description: 'Special offering day supporting global mission projects and evangelistic initiatives in unreached areas.',
      startDate: '2026-11-14',
      endDate: '2026-11-14',
      category: 'Mission',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // DECEMBER 2026
    {
      id: 135,
      title: 'Annual Stewardship Sabbath',
      description: 'Special Sabbath emphasizing faithful stewardship of time, talents, and resources for God\'s kingdom.',
      startDate: '2026-12-05',
      endDate: '2026-12-05',
      category: 'Stewardship',
      level: 'GC',
      levelName: 'General Conference',
      organizer: 'General Conference',
      isOnline: false,
    },

    // West-Central Africa Division Events
    {
      id: 5,
      title: 'WAD Youth Congress',
      description: 'West-Central Africa Division youth gathering for leadership training and spiritual empowerment.',
      startDate: '2026-07-20',
      endDate: '2026-07-25',
      location: 'Accra, Ghana',
      category: 'Youth',
      level: 'Division',
      levelName: 'West-Central Africa Division',
      organizer: 'West-Central Africa Division',
      image: 'https://readdy.ai/api/search-image?query=Large%20African%20youth%20congress%20with%20thousands%20of%20young%20people%20in%20modern%20convention%20center%20energetic%20worship%20colorful%20African%20attire%20dynamic%20stage%20production&width=800&height=500&seq=wad-youth-003&orientation=landscape',
      attendees: 8000,
      isOnline: false,
    },
    {
      id: 6,
      title: 'WAD Ministerial Council',
      description: 'Strategic gathering of pastors and church leaders across West-Central Africa for ministry excellence.',
      startDate: '2026-05-10',
      endDate: '2026-05-14',
      location: 'Abidjan, Ivory Coast',
      category: 'Leadership',
      level: 'Division',
      levelName: 'West-Central Africa Division',
      organizer: 'West-Central Africa Division',
      attendees: 500,
      isOnline: true,
    },
    {
      id: 7,
      title: 'WAD Women\'s Convention',
      description: 'Empowering women leaders across West-Central Africa through faith-based training and fellowship.',
      startDate: '2026-09-05',
      endDate: '2026-09-08',
      location: 'Lagos, Nigeria',
      category: 'Women',
      level: 'Division',
      levelName: 'West-Central Africa Division',
      organizer: 'West-Central Africa Division',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20African%20women%20convention%20with%20beautifully%20dressed%20Nigerian%20women%20in%20traditional%20attire%20sophisticated%20venue%20inspiring%20speakers%20warm%20atmosphere&width=800&height=500&seq=wad-women-004&orientation=landscape',
      attendees: 3000,
      isOnline: false,
    },

    // Union-Level Events (Nigeria)
    {
      id: 8,
      title: 'National Youth Congress 2026',
      description: 'Annual gathering of Adventist youth from across Nigeria for spiritual renewal and leadership training.',
      startDate: '2026-12-15',
      endDate: '2026-12-18',
      time: '9:00 AM - 6:00 PM',
      location: 'National Stadium, Abuja',
      category: 'Youth',
      level: 'Union',
      levelName: 'Nigeria Union Mission',
      organizer: 'Nigeria Union Mission',
      union: 'Nigeria Union',
      image: 'https://readdy.ai/api/search-image?query=Massive%20Nigerian%20youth%20conference%20with%20thousands%20of%20young%20people%20in%20stadium%20setting%20colorful%20stage%20production%20energetic%20worship%20contemporary%20atmosphere&width=800&height=500&seq=union-youth-005&orientation=landscape',
      attendees: 5000,
      isOnline: false,
    },
    {
      id: 9,
      title: 'Pathfinder Camporee',
      description: 'National Pathfinder camping event featuring outdoor skills, spiritual activities, and fellowship.',
      startDate: '2026-08-10',
      endDate: '2026-08-15',
      location: 'Jos, Plateau State',
      category: 'Youth',
      level: 'Union',
      levelName: 'Nigeria Union Mission',
      organizer: 'Nigeria Union Mission',
      union: 'Nigeria Union',
      attendees: 2000,
      isOnline: false,
    },
    {
      id: 10,
      title: 'Evangelism Training Workshop',
      description: 'Equipping church members across Nigeria with practical evangelism skills and biblical knowledge.',
      startDate: '2026-02-05',
      endDate: '2026-02-07',
      time: '8:00 AM - 4:00 PM',
      location: 'Ibadan Training Center',
      category: 'Training',
      level: 'Union',
      levelName: 'Nigeria Union Mission',
      organizer: 'Nigeria Union Mission',
      union: 'Nigeria Union',
      attendees: 500,
      isOnline: true,
    },
    {
      id: 11,
      title: 'Health & Wellness Expo',
      description: 'Promoting healthy living through health screenings, nutrition workshops, and wellness seminars.',
      startDate: '2026-03-10',
      endDate: '2026-03-10',
      time: '9:00 AM - 6:00 PM',
      location: 'Port Harcourt Exhibition Center',
      category: 'Health',
      level: 'Union',
      levelName: 'Nigeria Union Mission',
      organizer: 'Nigeria Union Mission',
      union: 'Nigeria Union',
      image: 'https://readdy.ai/api/search-image?query=Modern%20health%20expo%20with%20exhibition%20booths%20health%20screening%20stations%20fitness%20demonstrations%20vibrant%20atmosphere%20professional%20medical%20equipment%20Nigerian%20attendees&width=800&height=500&seq=union-health-006&orientation=landscape',
      attendees: 1500,
      isOnline: false,
    },
  ];

  // Smart event loading: Get next 3 upcoming events (excluding National holidays)
  const upcomingEvents = useMemo(() => {
    const referenceDate = new Date('2026-01-01'); // Starting from January 2026
    
    // Filter out National holidays and get events after reference date
    const eligibleEvents = allCalendarEvents
      .filter(event => event.level !== 'National') // Exclude national holidays
      .filter(event => new Date(event.startDate) >= referenceDate)
      .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
    
    // Get the next 3 events
    return eligibleEvents.slice(0, 3).map(event => {
      const startDate = new Date(event.startDate);
      const endDate = new Date(event.endDate);
      const isSameDay = startDate.toDateString() === endDate.toDateString();
      
      return {
        id: event.id,
        title: event.title,
        category: event.levelName,
        badge: event.level === 'GC' ? 'Global' : event.level === 'Division' ? 'Division' : 'Union',
        organizer: event.organizer || event.levelName,
        date: isSameDay 
          ? startDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
          : `${startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`,
        time: 'All Local Churches',
        thumbnail: event.image || 'https://readdy.ai/api/search-image?query=Seventh-day%20Adventist%20church%20event%20with%20diverse%20congregation%20worship%20service%20spiritual%20gathering%20contemporary%20church%20setting&width=800&height=500&seq=default-event-' + event.id + '&orientation=landscape'
      };
    });
  }, []);

  const featuredMinistries = [
    {
      id: 1,
      name: 'Lagos Central Choir',
      category: 'Music Ministry',
      badge: 'Conference Recognized',
      region: 'Southwest Region',
      description: 'Award-winning choir specializing in contemporary and traditional Adventist hymns with over 80 active members',
      languages: ['English', 'Yoruba'],
      thumbnail: 'https://readdy.ai/api/search-image?query=professional%20church%20choir%20in%20elegant%20robes%20singing%20harmoniously%20during%20worship%20service%20beautiful%20choir%20performance%20with%20conductor%20leading%20talented%20singers&width=800&height=500&seq=lagos-choir-ministry&orientation=landscape',
      social: {
        youtube: true,
        facebook: true,
        instagram: true
      }
    },
    {
      id: 2,
      name: 'Hope Evangelism Network',
      category: 'Evangelism Ministry',
      badge: 'Union Recognized',
      region: 'North Central Region',
      description: 'Dedicated to spreading the gospel through community outreach, health seminars, and public evangelistic campaigns',
      languages: ['English', 'Hausa'],
      thumbnail: 'https://readdy.ai/api/search-image?query=community%20evangelism%20outreach%20with%20volunteers%20distributing%20materials%20and%20talking%20with%20people%20outdoor%20ministry%20event%20with%20friendly%20interactions%20gospel%20sharing&width=800&height=500&seq=hope-evangelism-network&orientation=landscape',
      social: {
        youtube: true,
        facebook: true
      }
    },
    {
      id: 3,
      name: 'Youth Alive Movement',
      category: 'Youth Ministry',
      badge: 'Official',
      region: 'Nationwide',
      description: 'Empowering young Adventists through leadership training, spiritual retreats, and digital evangelism initiatives',
      languages: ['English', 'Pidgin'],
      thumbnail: 'https://readdy.ai/api/search-image?query=dynamic%20youth%20ministry%20group%20with%20young%20people%20engaged%20in%20activities%20leadership%20training%20session%20with%20enthusiastic%20participants%20modern%20youth%20gathering&width=800&height=500&seq=youth-alive-movement&orientation=landscape',
      social: {
        youtube: true,
        facebook: true,
        instagram: true,
        tiktok: true
      }
    },
    {
      id: 4,
      name: 'Adventist Health Professionals',
      category: 'Health Ministry',
      badge: 'Official',
      region: 'Nationwide',
      description: 'Medical professionals providing health education, free clinics, and wellness programs in underserved communities',
      languages: ['English', 'Igbo', 'Hausa'],
      thumbnail: 'https://readdy.ai/api/search-image?query=medical%20professionals%20in%20white%20coats%20providing%20healthcare%20services%20at%20community%20clinic%20doctors%20and%20nurses%20helping%20patients%20compassionate%20healthcare%20ministry&width=800&height=500&seq=health-professionals-ministry&orientation=landscape',
      social: {
        youtube: true,
        facebook: true
      }
    }
  ];

  return (
    <>
      {/* Upcoming Events Section */}
      <div className="py-16 sm:py-20 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-4" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
              Upcoming Programs & Events
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Special programs, conferences, and union-wide initiatives scheduled across Nigeria
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
            {upcomingEvents.map((event) => (
              <div
                key={event.id}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-200 group cursor-pointer"
              >
                <div className="relative">
                  <div className="w-full h-40 sm:h-48">
                    <img
                      src={event.thumbnail}
                      alt={event.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="bg-emerald-600 text-white px-2 sm:px-3 py-1 rounded-full text-xs font-semibold">
                      {event.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-emerald-600 transition-colors">
                    {event.title}
                  </h3>
                  <div className="flex items-start space-x-2 text-gray-600 text-xs sm:text-sm mb-2">
                    <i className="ri-building-line mt-0.5 flex-shrink-0"></i>
                    <span className="line-clamp-2">{event.organizer}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600 text-xs sm:text-sm mb-2">
                    <i className="ri-calendar-line flex-shrink-0"></i>
                    <span>{event.date}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600 text-xs sm:text-sm mb-4">
                    <i className="ri-time-line flex-shrink-0"></i>
                    <span>{event.time}</span>
                  </div>
                  <div className="flex items-center justify-between gap-2">
                    <button className="flex items-center space-x-2 px-3 sm:px-4 py-2 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer text-xs sm:text-sm">
                      <span>Learn More</span>
                      <i className="ri-arrow-right-line"></i>
                    </button>
                    <span className="bg-emerald-100 text-emerald-700 text-xs px-2 sm:px-3 py-1 rounded-full font-semibold">
                      {event.badge}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/events"
              className="inline-flex items-center space-x-2 px-6 sm:px-8 py-3 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              <span>View Full Calendar</span>
              <i className="ri-calendar-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Featured Ministries Section */}
      <div className="py-16 sm:py-20 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-4" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
              Featured Ministries & Organizations
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Discover trusted Adventist choirs, evangelists, and ministry organizations serving communities across Nigeria
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
            {featuredMinistries.map((ministry) => (
              <div
                key={ministry.id}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-200 group cursor-pointer"
              >
                <div className="relative">
                  <div className="w-full h-40 sm:h-48">
                    <img
                      src={ministry.thumbnail}
                      alt={ministry.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="bg-purple-600 text-white px-2 sm:px-3 py-1 rounded-full text-xs font-semibold">
                      {ministry.category}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="bg-emerald-600 text-white px-2 sm:px-3 py-1 rounded-full text-xs font-semibold">
                      {ministry.badge}
                    </span>
                  </div>
                </div>
                <div className="p-4 sm:p-5">
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                    {ministry.name}
                  </h3>
                  <div className="flex items-start space-x-2 text-gray-600 text-xs sm:text-sm mb-3">
                    <i className="ri-map-pin-line mt-0.5 flex-shrink-0"></i>
                    <span className="line-clamp-1">{ministry.region}</span>
                  </div>
                  <p className="text-gray-600 text-xs sm:text-sm mb-4 line-clamp-3">
                    {ministry.description}
                  </p>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2 text-gray-500 text-xs">
                      <i className="ri-global-line flex-shrink-0"></i>
                      <span className="line-clamp-1">{ministry.languages.join(', ')}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center space-x-3">
                      {ministry.social.youtube && (
                        <i className="ri-youtube-line text-gray-400 hover:text-red-600 cursor-pointer transition-colors text-lg"></i>
                      )}
                      {ministry.social.facebook && (
                        <i className="ri-facebook-circle-line text-gray-400 hover:text-blue-600 cursor-pointer transition-colors text-lg"></i>
                      )}
                      {ministry.social.instagram && (
                        <i className="ri-instagram-line text-gray-400 hover:text-pink-600 cursor-pointer transition-colors text-lg"></i>
                      )}
                      {ministry.social.tiktok && (
                        <i className="ri-tiktok-line text-gray-400 hover:text-gray-900 cursor-pointer transition-colors text-lg"></i>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/ministries"
              className="inline-flex items-center space-x-2 px-6 sm:px-8 py-3 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              <span>Explore All Ministries</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
